import { Button, Tooltip } from 'antd'
import { safeOrderReturn } from '@/lib/order-role-context'
import { useCurrentUser } from '@/hooks/use-auth'
import { isTabAccessibleForRole } from '@/lib/menu/utils'
import { menuConfig } from '@/lib/menu/config'
import { Link, useSearchParams, type LinkProps } from 'react-router-dom'

export function financeReturnPath(value: string | null): string | null {
  return safeOrderReturn(value)
}

export function withFinanceReturn(to: string, returnTo: string | null): string {
  const safe = financeReturnPath(returnTo)
  if (!safe || !to.startsWith('/dashboard/')) return to
  const [path, search] = to.split('?')
  const params = new URLSearchParams(search)
  params.set('returnTo', safe)
  return path + '?' + params.toString()
}

export function FinanceLink({ to, ...props }: LinkProps) {
  const [params] = useSearchParams()
  return <Link {...props} to={typeof to === 'string' ? withFinanceReturn(to, params.get('returnTo')) : to} />
}

export function OrderReturnLink() {
  const [params] = useSearchParams()
  const { data: user } = useCurrentUser()
  const target = financeReturnPath(params.get('returnTo'))
  const path = target?.split(/[?#]/)[0]
  const allowed = path && (user?.roles || []).some((role: any) => isTabAccessibleForRole(path, role === 'ADMIN' ? null : role, menuConfig))
  return target && allowed ? <div className="mb-3"><Tooltip title="返回原页面，恢复来源列表和订单详情"><Link to={target}><Button>返回来源页面</Button></Link></Tooltip></div> : null
}

/** Kept for old imports; the dashboard now renders the single shared return link. */
export function FinanceReturnLink() { return null }
